export type ClockIconProps = {
  stroke?: string
}
export function ClockIcon(props: ClockIconProps) {
  const stroke = props.stroke || 'stroke-primary dark:stroke-primaryDark'

  return (
    <svg
      viewBox="0 0 14 14"
      className={`h-full w-auto ${stroke}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {' '}
      <path
        d="M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />{' '}
      <path d="M7 3.40004V7.00004L9.4 8.20004" strokeLinecap="round" strokeLinejoin="round" />{' '}
    </svg>
  )
}
